import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Link } from 'components/core/Link';
import { Image } from 'components/core/Image';

import { Logo } from 'components/svg';
import { ClickToShowNumberButton } from 'components/contact/ClickToShowNumberButton';
import DealsLink from 'components/brand/Header/DealsLink';
import HolidayBanner from 'components/brand/Header/HolidayBanner';
import useExperiment from 'hooks/useExperiment';

import holidayMessaging from 'config/holidayMessaging';
import HeaderMenu from './HeaderMenu';

import './header.scss';

export function Header({
	hideMenu,
	hideDealsLink,
	getTollfreePhoneNumber,
	holiday,
	// sf_12700_sfdc_paid_landing_refresh
	parentPhoneNumber,
	setParentPhoneNumber,
	parentPhoneLoaded,
	setParentPhoneLoaded,
	className,
}) {
	const { sf12289Variation } = useExperiment(
		'sf_12289_sfdc_holiday_messaging',
	);
	const holidayVariation = sf12289Variation === 'variation' && holiday;

	return (
		<header
			className={classnames(
				'ph-header',
				className,
				{ 'holiday-header': holidayVariation },
				holidayVariation &&
					`header-theme-${holidayMessaging[holiday].secondaryColor}`,
			)}
		>
			<div className="main-menu">
				<Link
					href="/"
					className="logo-link"
					hideBorder
				>
					{holidayVariation && (
						<Image
							className="holiday-icon"
							src={holidayMessaging[holiday].icon}
							alt={holidayMessaging[holiday].iconAlt}
						/>
					)}
					<Logo
						titleID="sparefoot-header-title"
						color={
							holidayVariation &&
							holidayMessaging[holiday].primaryColor
						}
					/>
				</Link>
				{!hideMenu && <HeaderMenu />}
				{!hideDealsLink && <DealsLink className="hide-on-desktop" />}
				<ClickToShowNumberButton
					outline
					fetchPhoneNumber={getTollfreePhoneNumber}
					showAsLink
					size="small"
					parentPhoneNumber={parentPhoneNumber}
					setParentPhoneNumber={setParentPhoneNumber}
					parentPhoneLoaded={parentPhoneLoaded}
					setParentPhoneLoaded={setParentPhoneLoaded}
				/>
			</div>
			{holidayVariation && <HolidayBanner holiday={holiday} />}
		</header>
	);
}

Header.propTypes = {
	hideMenu: PropTypes.bool,
	hideDealsLink: PropTypes.bool,
	getTollfreePhoneNumber: PropTypes.func.isRequired,
	holiday: PropTypes.bool,
	// sf_12700_sfdc_paid_landing_refresh
	parentPhoneNumber: PropTypes.object,
	setParentPhoneNumber: PropTypes.func,
	parentPhoneLoaded: PropTypes.bool,
	setParentPhoneLoaded: PropTypes.func,
	className: PropTypes.string,
};

export default Header;
